module.exports = __webpack_public_path__ + "img/layer1.2882988e.png";